import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="bg-secondary-800 text-secondary-200">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <span className="font-display text-xl text-background-50">迷妹漫画</span>
            <p className="mt-3 text-sm text-secondary-300 leading-relaxed">
              迷妹漫画网聚合漫画全集、完结漫画与漫画完整版资源，提供完结漫画大全一站式在线浏览，支持竖屏连续滚动阅读，让漫画迷一次性补完大结局。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-secondary-300 hover:text-background-50 transition-colors">首页</Link></li>
              <li><Link to="/about" className="text-sm text-secondary-300 hover:text-background-50 transition-colors">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">漫画分类</h4>
            <ul className="grid grid-cols-2 gap-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap">
                    {cat.name}漫画
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">关注我们</h4>
            <p className="text-sm text-secondary-300 mb-3">随时随地追更，不错过任何精彩</p>
            <div className="flex gap-3">
              <span className="w-9 h-9 rounded-full bg-secondary-700 flex items-center justify-center cursor-pointer hover:bg-secondary-600 transition-colors">
                <i className="ri-wechat-line text-background-50"></i>
              </span>
              <span className="w-9 h-9 rounded-full bg-secondary-700 flex items-center justify-center cursor-pointer hover:bg-secondary-600 transition-colors">
                <i className="ri-weibo-line text-background-50"></i>
              </span>
              <span className="w-9 h-9 rounded-full bg-secondary-700 flex items-center justify-center cursor-pointer hover:bg-secondary-600 transition-colors">
                <i className="ri-bilibili-line text-background-50"></i>
              </span>
            </div>
          </div>
        </div>

        <div className="border-t border-secondary-700 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-secondary-400">
            &copy; 2026 迷妹漫画 mimeimanga.com - 本站所有漫画均来自网络，版权归原作者所有。
          </p>
          <div className="flex gap-4 text-xs text-secondary-400">
            <span className="hover:text-background-50 cursor-pointer transition-colors">隐私政策</span>
            <span className="hover:text-background-50 cursor-pointer transition-colors">服务条款</span>
            <span className="hover:text-background-50 cursor-pointer transition-colors">免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}